import { loadStripe } from '@stripe/stripe-js';

const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_jWLvOYrIbXg4MCCdGc2H0gO200WwznkW0U';

export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
